import { useState } from "react";

const LocationDetails = ({ data }) => {
  const [showTooltip, setShowTooltip] = useState(false);

  const locations = [data?.sales_person?.dist_name && `${data.sales_person.dist_name} (D)`, data?.sales_person?.const_name && `${data.sales_person.const_name} (C)`].filter(Boolean);

  if (!locations.length) return null;

  const maxVisible = 2;
  const visibleLocations = locations.slice(0, maxVisible);
  const remainingCount = locations.length - maxVisible;

  return (
    <div className="relative max-w-[120px]" onMouseEnter={() => setShowTooltip(true)} onMouseLeave={() => setShowTooltip(false)}>
      {showTooltip && (
        <div className="absolute z-50 bottom-full mb-2 w-64 bg-black text-white text-xs rounded-md px-3 py-2 shadow-lg">
          {locations.map((loc, i) => (
            <div key={i}>• {loc}</div>
          ))}
        </div>
      )}

      <div className="flex gap-1 overflow-hidden whitespace-nowrap text-ellipsis">
        {visibleLocations.map((item, index) => (
          <span key={index} className="text-xs bg-gray-100 text-gray-700 px-2 py-1 rounded-md shrink-0">
            {item}
          </span>
        ))}
        {remainingCount > 0 && <span className="text-xs bg-gray-100 text-gray-700 px-2 py-1 rounded-md shrink-0">+{remainingCount} more</span>}
      </div>
    </div>
  );
};

export default LocationDetails;
